import SearchHeader from "../../../components/function/filters/SearchHeader";
import HeaderLayout from "../../../layouts/Header";
import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { useNav } from '../../../hooks/useNav'
import { PATH } from "../../../data/router_path";
import { DEFAULT_PAGE_NUMBER } from "../../../data/constants";
import DropDownList from "../../../components/function/filters/DropDownList";
import { addDefaultDropDown } from "../../../utils/conversion";
import { useEffect } from 'react'

const SORT_OPTIONS = [
  { label: 'Tên gói sách (A đến Z)', value: '1' },
  { label: 'Ngày tạo (Cũ nhất)', value: '2' },
  { label: 'Ngày tạo (Mới nhất)', value: '3' },
  { label: 'Số lượng sách', value: '4' },
]

const bookPackageFilterSchema = z.object({
  keywords: z.string().nullable().optional(),
  option: z.string().optional().nullable(),
})
export default function BookPackageHeader() {
  const navigate = useNav()
  const { control, handleSubmit, watch } = useForm({
    resolver: zodResolver(bookPackageFilterSchema),
    defaultValues: {
      keywords: '',
      option: undefined,
    },
  })
  const [option] = watch(['option'])

  const searchHandler = (formValue) => {
    const { keywords, option } = formValue
    const filters = { keywords, option, pageNumber: DEFAULT_PAGE_NUMBER }
    navigate(PATH.BOOK.PACKAGE, { params: filters })
  }
  useEffect(() => {
    handleSubmit(searchHandler)()
  }, [option])
  return (
    <HeaderLayout>
      <form
        onSubmit={handleSubmit(searchHandler)}
        className={'flex flex-col justify-center gap-4'}
      >
        <SearchHeader
          title={'Quản lý gói sách'}
          placeholder="Tìm kiếm gói sách theo tên"
          control={control}
          name={'keywords'}
        />
        <div className="flex justify-end">
          <DropDownList
            control={control}
            name={'option'}
            title={'Lọc theo'}
            width="w-[180px]"
            itemWidth="w-[230px]"
            options={addDefaultDropDown(SORT_OPTIONS)}
          />
        </div>
      </form>
    </HeaderLayout>
  )
}